import { Container, Row, Col, Card, Spinner, InputGroup, FormControl, Button, Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logomarca from '../../assets/images/logo-hns-branco.png';
import { IMaskInput } from "react-imask";
import Style from './Login.module.css';

import { getConfig } from "../../common/config";

const LoginDefault = (props) => {
    const {
        // Estados
        loading,
        loading_ambiente,
        username,
        password,
        showPassword,
        segundo_fator,
        qrcode,
        token,
        showForgotPassword,
        emailForReset,
        cnpjForReset,
        tipo_pessoa,
        programa_dados,
        pParam,
        hasBothParams,
        accessType,
        handlers
    } = props;

    const isBeneficiarioFlow = accessType === 'beneficiario';

    let dynamicStyles = '';
    if(programa_dados) {
        if(programa_dados.layout_cor_fundo && programa_dados.layout_cor_primaria && programa_dados.layout_cor_secundaria) {
            dynamicStyles = `
                .login-page {
                    background: ${programa_dados.layout_cor_fundo};
                }
                .btn-first {
                    background: ${programa_dados.layout_cor_primaria};
                    border-color: ${programa_dados.layout_cor_primaria};
                }
                .btn-secondary {
                    background: ${programa_dados.layout_cor_secundaria};
                    border: 1px solid ${programa_dados.layout_cor_secundaria};
                }
                .btn-secondary:hover {
                    background: ${programa_dados.layout_cor_secundaria};
                    border: 1px solid ${programa_dados.layout_cor_secundaria};
                    opacity: 0.9;
                }
                .login-link-dynamic {
                    color: ${programa_dados.layout_cor_primaria} !important;
                }
            `;
        }
    }

    return (
        <div className="login-page">
            <style>{dynamicStyles}</style>
            <Container>
                <Row>
                    <Col lg={{ span: 4, offset: 4 }} sm={{ span: 6, offset: 3 }} xs={12}>
                        {!loading_ambiente ? (
                            <div className="text-center mb-4">
                                {programa_dados.imagem_branca ? (
                                    <div>
                                        <img src={programa_dados.imagem_branca} alt={programa_dados.nome} className={Style.loginLogomarca} />
                                    </div>
                                ) : (
                                    <img src={logomarca} alt="Aditus" />
                                )}
                            </div>
                        ) : (
                            <div className="text-center">
                                <Spinner animation="border" className={Style.loginSpinner} />
                            </div>
                        )}
                        <Card className="mt-5">
                            <Card.Body>
                                {segundo_fator ? (
                                    <form onSubmit={handlers.handleLogin} className="text-center">
                                        <div className="form-group mb-2 d-flex flex-column align-items-center">
                                            {qrcode && (
                                                <div className="text-center">
                                                    <h6 className="mb-3">Vamos habilitar a autenticação com 2 Fatores em seu perfil!<br />Siga os passos abaixo:</h6>
                                                    <p><strong>1º</strong> - Escaneie o QR Code abaixo com seu app autenticador (Microsoft Authenticator, etc.)</p>
                                                    <img src={qrcode} alt="QR Code 2FA" className="qrcode mx-auto mb-2 w-50" />
                                                    <p><strong>2º</strong> - Informe o código gerado no app autenticador no campo a seguir:</p>
                                                </div>
                                            )}
                                            <label htmlFor="token" className="mb-2">Código de verificação</label>
                                            <input
                                                type="text"
                                                className="form-control w-75 mx-auto"
                                                name="token"
                                                value={token}
                                                onChange={(e) => handlers.setToken(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group mb-2 text-center">
                                            <button
                                                className="mt-3 btn btn-first btn-block w-75"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <span>Enviar</span>
                                                )}
                                            </button>
                                        </div>
                                    </form> 
                                ) : (
                                    <>
                                        {showForgotPassword ? (
                                            <>
                                                {!isBeneficiarioFlow && (
                                                    <Row>
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Qual é o tipo de cadastro?</Form.Label>
                                                                <div>
                                                                    <Button 
                                                                        variant={tipo_pessoa === 'fisica' ? "success" : "outline-secondary"}
                                                                        onClick={() => handlers.setTipoPessoa('fisica')}>
                                                                        Pessoa Física
                                                                    </Button>
                                                                    {' '}
                                                                    <Button 
                                                                        variant={tipo_pessoa === 'juridica' ? "success" : "outline-secondary"}
                                                                        onClick={() => handlers.setTipoPessoa('juridica')}>
                                                                        Pessoa Jurídica
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                )}
                                                <Form onSubmit={handlers.handlePasswordReset}>
                                                    {isBeneficiarioFlow && (
                                                        <div className="mb-3 text-muted">
                                                            Informe o e-mail cadastrado para receber o link de redefinição de senha do paciente.
                                                        </div>
                                                    )}
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Informe seu e-mail de cadastro</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            value={emailForReset}
                                                            onChange={(e) => handlers.setEmailForReset(e.target.value.toLowerCase())}
                                                            required
                                                        />
                                                    </Form.Group>
                                                    {!isBeneficiarioFlow && tipo_pessoa !== 'fisica' && (
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Informe seu CNPJ</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={cnpjForReset}
                                                                onChange={(e) => handlers.setCnpjForReset(e.target.value)}
                                                                required
                                                                as={IMaskInput}
                                                                mask="00.000.000/0000-00"
                                                            />
                                                        </Form.Group>
                                                    )}
                                                    <div className="text-center">
                                                        <Button variant="success" size="sm" type="submit" disabled={loading}>
                                                            Solicitar Redefinição
                                                        </Button>
                                                        <Button variant="danger" size="sm" onClick={handlers.toggleForgotPassword} className="ms-2">
                                                            Cancelar
                                                        </Button>
                                                    </div>
                                                </Form>
                                            </>
                                        ) : (
                                            <form onSubmit={handlers.handleLogin}>
                                                <div className="form-group mb-3">
                                                    <label htmlFor="username">E-mail</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="username"
                                                        value={username}
                                                        onChange={handlers.onChangeUsername}
                                                        autoComplete="username"
                                                    />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label htmlFor="password">Senha</label>
                                                    <InputGroup>
                                                        <FormControl
                                                            type={showPassword ? 'text' : 'password'}
                                                            value={password}
                                                            required
                                                            onChange={handlers.onChangePassword}
                                                            autoComplete="current-password"
                                                        />
                                                        <InputGroup.Text
                                                            className={Style.clickable}
                                                            onClick={handlers.toggleShowPassword}
                                                        >
                                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                        </InputGroup.Text>
                                                    </InputGroup>
                                                </div>
                                                <div className="form-group mb-2 text-center">
                                                    <button
                                                        className="btn btn-first mt-3 btn-block"
                                                        disabled={loading}
                                                    >
                                                        {loading ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : (
                                                            <span>Entrar</span>
                                                        )}
                                                    </button>
                                                </div>
                                                <div className="text-center mt-4">
                                                    <a href="#" onClick={handlers.toggleForgotPassword} className={`d-block mt-3 ${Style.loginLink} login-link-dynamic`}>
                                                        Esqueceu a senha?
                                                    </a>
                                                </div>
                                            </form>
                                        )}
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                        
                        {hasBothParams && !isBeneficiarioFlow && !loading_ambiente && getConfig(programa_dados.configuracoes, 'prestador.habilita_cadastro_medico', true) === true && (
                            <div className="text-center mt-5">
                                <a href={`/prestadores/cadastro/?p=${pParam}`} className={`btn btn-secondary w-100 ${Style.loginBtnCadastro}`}>
                                    Primeiro Contato? Cadastre-se Aqui
                                </a>
                            </div>
                        )}
                        {programa_dados.imagem_branca && (
                            <div className="mt-5 text-center">
                                <p className="text-white">Powered by <a href="https://aditushealth.com.br" target="_blank" rel="noreferrer"><img src={logomarca} alt="Aditus Health" className={`ms-1 ${Style.loginPoweredBy}`} /></a></p>
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LoginDefault;
